export const environment: {
  platformHost: string;
  production: boolean;
} = {
  platformHost:
    window.location.hostname.indexOf('.stage.gpgdevs.com') === -1
      ? 'https://platform.prod.gprince.net'
      : 'https://platform.stage.gpgdevs.com',
  production: true,
};